var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherMarginsTestPages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 14.3235,
    width: 15,
    height: 1.82353,
    rx: 0.911765,
    stroke: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.2353C2.5 14.7317 2.90821 14.3235 3.41176 14.3235H6.67647V16.1471H3.41177C2.90821 16.1471 2.5 15.7389 2.5 15.2353Z",
    stroke: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94104 14.2941V12.6807M6.94104 12.6807V9.48695C6.94104 9.11928 7.34378 8.89362 7.65735 9.0856L9.57963 10.2625C9.87946 10.4461 9.87946 10.8816 9.57963 11.0652L6.94104 12.6807Z",
    stroke: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.45097C10 6.71086 9.78931 6.92155 9.52941 6.92155L3.41176 6.92155C3.15187 6.92155 2.94118 6.71086 2.94118 6.45097L2.94118 4.25489C2.94118 3.99499 3.15187 3.7843 3.41176 3.7843L9.52941 3.7843C9.78931 3.7843 10 3.99499 10 4.25489L10 6.45097Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7057 7.70588L13.1371 6.13725",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2744 6.13725L14.7058 7.70588",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7058 3V7.70588",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherMarginsTestPages);
export default ForwardRef;